// source/assets/cart-drawer.js
var MiniCart = class extends HTMLElement {
  constructor() {
    super();
    this.handlePopState = this.handlePopState.bind(this);
  }
  connectedCallback() {
    this.header = document.querySelector("sticky-header");
    this.drawer = document.querySelector("cart-drawer");
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    window.addEventListener("popstate", this.handlePopState);
  }
  disconnectedCallback() {
    window.removeEventListener("popstate", this.handlePopState);
  }
  handlePopState(event) {
    var _a;
    if (!this.drawer) return;
    const detailsElement = this.drawer.querySelector("details");
    if (detailsElement == null ? void 0 : detailsElement.hasAttribute("open")) {
      detailsElement.removeAttribute("open");
      this.drawer.closeMenuDrawer();
      if ((_a = window.history.state) == null ? void 0 : _a.cartOpen) {
        window.history.replaceState(null, "", window.location.pathname);
      }
    }
  }
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    fetch(this.dataset.url).then((response) => response.text()).then((html) => {
      document.getElementById("mini-cart").innerHTML = this.getSectionInnerHTML(html, ".shopify-section");
      document.dispatchEvent(new CustomEvent("cartdrawer:opened"));
    }).catch((e) => {
      console.error("MiniCart: Failed to load cart content", e);
    });
  }
  open() {
    var _a;
    const detailsElement = this.drawer.querySelector("details");
    if (detailsElement.hasAttribute("open")) {
      return;
    }
    if (!((_a = window.history.state) == null ? void 0 : _a.cartOpen)) {
      window.history.pushState(
        { cartOpen: true },
        "",
        window.location.pathname
      );
    }
    this.drawer.openMenuDrawer();
  }
  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });
    this.open();
  }
  getSectionsToRender() {
    return [
      {
        id: "mini-cart",
        section: "mini-cart",
        selector: ".shopify-section"
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section"
      },
      {
        id: "mobile-cart-icon-bubble",
        section: "mobile-cart-icon-bubble",
        selector: ".shopify-section"
      }
    ];
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
};
customElements.define("mini-cart", MiniCart);
//# sourceMappingURL=cart-drawer.js.map
